<div id="main-content">
    <app-header *ngIf="location != '/campus-life/student-grievance'"></app-header>
    <ng-snotify></ng-snotify>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
